import { useEffect, useState } from "react";
import { Facebook, Instagram, MessageCircle, Music2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../api";
import { useLang } from "../i18n";
import { Reveal, SectionHead } from "./Section";

export const SocialSection = () => {
    const { t } = useLang();
    const [cfg, setCfg] = useState(null);

    useEffect(() => {
        api.get("/payments/config").then((r) => setCfg(r.data)).catch(() => {});
    }, []);

    const links = [
        { label: "Instagram", icon: Instagram, url: cfg?.social_instagram, testId: "social-instagram" },
        { label: "TikTok", icon: Music2, url: cfg?.social_tiktok, testId: "social-tiktok" },
        { label: "Facebook", icon: Facebook, url: cfg?.social_facebook, testId: "social-facebook" },
        { label: "WhatsApp", icon: MessageCircle, url: cfg?.social_whatsapp, testId: "social-whatsapp" },
    ].filter((l) => l.url);

    const share = async () => {
        const url = window.location.origin;
        if (navigator.share) {
            try { await navigator.share({ title: "LAKOU — December 12, 2026", text: "LAKOU — More than an event. A feeling.", url }); } catch {}
        } else {
            try { await navigator.clipboard.writeText(url); toast.success(t("social_share_done")); } catch {}
        }
    };

    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 sm:pb-32" data-testid="social-section">
            <SectionHead eyebrow={t("social_eyebrow")} title={t("social_title")} testId="social-title" />
            <Reveal delay={0.05}>
                <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                    {links.map((l) => (
                        <a key={l.testId} href={l.url} target="_blank" rel="noopener noreferrer" data-testid={l.testId}
                            className="inline-flex items-center gap-3 rounded-full border border-lakou-gold/30 hover:border-lakou-gold bg-lakou-coal/60 px-7 py-4 font-display font-bold text-sm uppercase tracking-[0.15em] text-lakou-cream hover:text-lakou-gold transition-colors duration-300">
                            <l.icon size={17} /> {l.label}
                        </a>
                    ))}
                    <button onClick={share} data-testid="social-share"
                        className="inline-flex items-center gap-3 rounded-full bg-lakou-orange hover:bg-lakou-gold text-white hover:text-lakou-ink px-7 py-4 font-display font-bold text-sm uppercase tracking-[0.15em] transition-colors duration-300">
                        <Share2 size={17} /> {t("social_share")}
                    </button>
                </div>
            </Reveal>
        </section>
    );
};
